import en from './en.json';
import de from './de.json';
import fr from './fr.json';
import fi from './fi.json';
import es from './es.json';
import sv from './sv.json';
import nl from './nl.json';
import pt from './pt.json';
import hu from './hu.json';
import universal from './universal.json';

export default {
  universal,
  en,
  de,
  es,
  fi,
  fr,
  hu,
  sv,
  nl,
  pt,
};
